import { render, staticRenderFns } from "./queued_prompt_message.vue?vue&type=template&id=63926dc7"
import script from "./queued_prompt_message.vue?vue&type=script&lang=js"
export * from "./queued_prompt_message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports